<template>
  <div class="flex flex-col space-y-2">
    <div v-if="selectedLabels">
      {{ selectedLabels }}
    </div>
    <button
      class="w-full border border-gray-500 p-2"
      @click="isOpen = true"
    >
      選択してください
    </button>
    <BaseDialog
      :open="isOpen"
      @close="isOpen = false"
    >
      <div class="bg-white z-10 w-56">
        <DialogTitle class="mx-1 px-1 py-2 border-b border-gray-400">
          選択してください
        </DialogTitle>
        <DialogDescription class="py-1">
          <div class="flex flex-col overflow-auto max-h-80">
            <BaseArrayCheckbox
              v-for="(option, index) in options"
              :key="index"
              v-model="selected"
              :item="option.value"
              :disabled="isDisabled(option.value)"
              :class="[
                'px-2 py-1',
                !isDisabled(option.value) && 'hover:bg-gray-100'
              ]"
            >
              <div class="w-full break-words whitespace-pre-wrap" style="line-height: 115%;">
                {{ option.label || '&nbsp;' }}
              </div>
            </BaseArrayCheckbox>
          </div>
        </DialogDescription>
        <button
          class="bg-gray-900 text-white p-2 w-full"
          @click="isOpen = false"
        >
          戻る
        </button>
      </div>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import {
  DialogDescription,
  DialogTitle,
} from '@headlessui/vue';
import { computed, defineComponent, PropType, ref, toRefs } from 'vue';

import { OptionItem } from '@/models/option_item';
import { selectedText } from '@/utils/selected_text';
import { sortOptionsValue } from '@/utils/sort_options_value';

import BaseArrayCheckbox from './BaseArrayCheckbox.vue';
import BaseDialog from './BaseDialog.vue';

export default defineComponent({
  name: 'SurveyInputMultiSelect',
  components: {
    BaseDialog,
    DialogDescription,
    DialogTitle,
    BaseArrayCheckbox,
  },
  props: {

    /**
     *  選択されている値のリスト
     */
    modelValue: {
      type: Array as PropType<string[]>,
      default: () => [],
    },

    /**
     *  選択肢のリスト
     */
    options: {
      type: Array as PropType<OptionItem[]>,
      default: () => [],
    },

    /**
     *  選択できる最大の個数。
     *
     *  0 を入れた場合は無制限になる。
     */
    max: {
      type: Number,
      default: 0,
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(props, { emit }) {
    const { modelValue, max, options } = toRefs(props);

    const selected = computed({
      get: () => modelValue.value,
      set: (value: string[]) => emit('update:modelValue', sortOptionsValue(value, options.value)),
    });

    const isOpen = ref(false);

    function isDisabled(option: string) {
      return selected.value.length >= max.value
        && max.value !== 0
        && !selected.value.includes(option)
      ;
    }

    const selectedLabels = computed(() => {
      const labels = selected.value.map((s) => options.value.find((o) => o.value === s)?.label || '');
      return selectedText(labels);
    });

    return {
      selected,
      isDisabled,
      isOpen,
      selectedLabels,
    };
  },
});
</script>
